<router-outlet></router-outlet>
<div kendoDialogContainer></div>
<div class="loader" *ngIf="showLoader">
  <kendo-loader [type]="'pulsing'" [size]="'large'"></kendo-loader>
  <span class="loader__text">Requesting auth0 user info...</span>
</div>
